export const PageURLs = {
  // URLs in this object should end with a trailing slash '/'
  shareItemPage: '/item/share-item/',
};
